import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { CollectionCard as DSCollectionCard } from 'marketplace-discovery-studio-lib/components/CollectionCard';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { getPageCollectionPreviews, useCurrentPageId, usePagePlacements } from '../../hero/hooks/usePagePlacements';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { adaptDSPreviewItems, getCollectionUrl } from '../hooks/useDiscoveryCollections';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SuggestedCollections({
  placementCollections: placementCollectionsProp
}) {
  const pageId = useCurrentPageId();
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const {
    placementsBySection,
    loading: placementsLoading
  } = usePagePlacements(placementCollectionsProp === undefined ? pageId : undefined);
  const placementCollections = placementCollectionsProp !== null && placementCollectionsProp !== void 0 ? placementCollectionsProp : getPageCollectionPreviews(placementsBySection, pageId);
  const trackPlacementCollectionCardClicked = (collection, index) => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'collection card clicked',
      category: collection.slug,
      collectionId: collection.entityId,
      itemIndex: index,
      subscreen: Subscreens.SUGGESTED_COLLECTIONS
    }));
  };
  const trackCtaClicked = () => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'collection cta clicked',
      subscreen: Subscreens.SUGGESTED_COLLECTIONS
    }));
  };
  const sectionHeader = /*#__PURE__*/_jsxs(Flex, {
    flexWrap: "wrap",
    gap: "400",
    justifyContent: "space-between",
    paddingBlockEnd: "400",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.featuredCollection.ctaTitle"
      })
    }), /*#__PURE__*/_jsx(UIRouterLink, {
      to: Paths.FEATURED,
      onClick: trackCtaClicked,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.featuredCollection.ctaLink"
      })
    })]
  });
  if (placementCollectionsProp === undefined && placementsLoading && !placementCollections.length) {
    return undefined;
  }
  if (!placementCollections.length) {
    return undefined;
  }
  const isSingleCollection = placementCollections.length === 1;
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: "1000",
    children: [sectionHeader, /*#__PURE__*/_jsx(CardGrid, {
      columns: isSingleCollection ? 1 : 2,
      gap: "400",
      children: placementCollections.map((collection, index) => /*#__PURE__*/_jsx(DSCollectionCard, {
        title: collection.title || collection.name,
        description: collection.description ? /*#__PURE__*/_jsx(SanitizedText, {
          body: collection.description,
          WrapperComponent: "span"
        }) : undefined,
        buttonText: unescapedText('marketplaceStorefront.collectionCard.viewCollection'),
        buttonUrl: getCollectionUrl(collection.slug),
        previewItems: adaptDSPreviewItems(collection.previewItems),
        listingCount: collection.listingCount,
        sectionWidth: isSingleCollection ? 'FULL' : 'HALF',
        formatMoreCount: count => unescapedText('marketplaceStorefront.collectionCard.previewMore', {
          count
        }),
        onClick: () => {
          trackPlacementCollectionCardClicked(collection, index);
          scrollToTop();
        }
      }, collection.slug))
    })]
  });
}